import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=980fd480&"
import script from "./VideoCall.vue?vue&type=script&lang=js&"
export * from "./VideoCall.vue?vue&type=script&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=980fd480&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports